import { Entity } from '../api/entity-schema';

export const formatTicker = (entity: Pick<Entity, 'ticker' | 'exchange'>) => {
  const exchangeCode = entity?.exchange?.code ? `:${entity.exchange.code}` : '';
  return `${entity.ticker}${exchangeCode}`.toUpperCase();
};
